// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1snBZ","inner":"Form_inner___mAKY","range":"Form_range__1ZkAI","name":"Form_name__35h1a","actions":"Form_actions__3Oxwt"};